export default class SelectScoutMessage {
  constructor() {
    document.addEventListener('DOMContentLoaded', this.initialize);
  }

  initialize() {
    const node = Array.from(document.querySelectorAll('.js-select-scoutMessage'));
    node.forEach((el) => {
      new Vue({
        el,
        name: 'SelectScoutMessage',
        data() {
          return {
            selected: 0,
            options: [],
            selectMessage: '',
            selectTitle: '「興味あるしてくれた人をプロジェクトにお誘いしたい」',
            selectTemplate: '',
            selectedBefore: '',
            alertMessage: false,
            editingText: '',
          };
        },
        mounted() {
          const messageTemplates = JSON.parse(this.$el.getAttribute('data-options'));
          messageTemplates.forEach((messageTemplate) => {
            const messageTemplateJson = JSON.parse(messageTemplate);
            this.options.push({ text: messageTemplateJson.title, value: messageTemplateJson.content });
          });

          this.selectMessage = this.options[0].message;
          this.selectTemplate = this.options[0].value;
        },
        methods: {
          onChangeText(index) {
            if (this.alertMessage) {
              const result = window.confirm('入力内容を差し替えます。\nよろしいですか？');
              if (result) {
                this.alertMessage = false;
              } else {
                // 選択変更のキャンセル時のselectを保持
                this.selected = this.selectedBefore;
                this.selectTemplate = this.editingText;
                return;
              }
            }
            this.selectTitle = this.options[index].text;
            this.selectTemplate = this.options[index].value;
            this.selectMessage = this.options[index].message;
          },
          onChangeKeyUp() {
            this.selectedBefore = this.selected;
            this.alertMessage = true;
            this.editingText = this.selectTemplate;
          },
          onRouteUpdate(event) {
            if (this.alertMessage) {
              const result = window.confirm('ページを移動してもよろしいですか？\n変更された内容が破棄されます。');
              if (result) {
                this.alertMessage = false;
              } else {
                event.preventDefault();
              }
            }
          },
          focusTextarea() {
            if (this.selected === 4 && this.selectTemplate === '自由に内容を入力してください。') {
              this.selectTemplate = '';
            }
          },
          blurTextarea() {
            if (this.selected === 4 && this.selectTemplate === '') {
              this.selectTemplate = '自由に内容を入力してください。';
            }
          },
        },
      });
    });
  }
}
